import { bookedAppointmentsRatingReducer } from "./booked-appoinments-rating";
import { bookedAppointmentsReducer } from "./bookedAppointments";
/**
 * combineReducers defines the structure of the store object.
 */
import { combineReducers } from "redux";
import { createAppointmentReducer } from "./createAppointmentData";
import { noticationListReducer } from "./notifications";
import { paymentReducer } from "./payment";
import { petCareReducer } from "./petCareData";
import { petReducer } from "./pet";
import { rescheduleSourceReducer } from "./recheduleSource/rescheduleSource.reducer";
import { retirePetReducer } from "./retirePet";
import { stepperReducer } from "./stepper/stepper.reducer";
import { toastReducer } from "./request";
import { updateLocationReducer } from "./updateLocation";
import { userReducer } from "./user";
import { wellnessPlanReducer } from "./wellness-plan-details";
import { contentfulDataReducer } from "./contentfulData/contentfulData.reducer";
import { overdueInvoiceReducer } from "./pendingInvoices";
import { hosiptalDetailsListReducer } from "./hospital-list-details";
import { bookingAppointmentTypeReducer } from "./booking-appointment-type";
import { expressNotificationListReducer } from "./express-notifications";
import { allServiceStatusReducer } from "./all-service-status";
import { bookingReasonsNavigationReducer } from "./booking-reasons-navigation";
import { combinedAlertsDataReducer } from "./combined-alerts-data";
import { wellnessModalStatusReducer } from "./wellnessModalStatus";
import { wellnessPurchaseReducer } from "./wellness-purchase-data";
import { urgentVisitReducer } from "./urgent-visit";


const appReducer = combineReducers({
  stepper: stepperReducer,
  user: userReducer,
  toastMessage: toastReducer,
  pet: petReducer,
  payment: paymentReducer,
  updateLocation: updateLocationReducer,
  notications: noticationListReducer,
  rescheduleSource: rescheduleSourceReducer,
  carePage: petCareReducer,
  retirePet: retirePetReducer,
  wellnessPlan: wellnessPlanReducer,
  wellnessPurchaseData: wellnessPurchaseReducer,

  // cleaned reducers below
  appointments: bookedAppointmentsReducer,
  createAppointment: createAppointmentReducer,
  appointmentUserRating: bookedAppointmentsRatingReducer,
  contentfulData: contentfulDataReducer,
  overdueInvoiceData: overdueInvoiceReducer,
  hospitalDetailsList: hosiptalDetailsListReducer,
  bookingAppointmentType: bookingAppointmentTypeReducer,
  expressNotifications: expressNotificationListReducer,
  allServiceStatus: allServiceStatusReducer,
  bookingReasonsNavigation: bookingReasonsNavigationReducer,
  wellnessModalStatus: wellnessModalStatusReducer,
  combinedAlertsData: combinedAlertsDataReducer,
  urgentVisit: urgentVisitReducer,

});

export const rootReducer = (state: any, action: any) => {
  if (action.type === "LOGOUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export type IRootState = ReturnType<typeof rootReducer>;

